
import { defineComponent, ref, watch } from 'vue';
import { UserService } from '@/core/services/UserService';
import { swalErrNotification, swalNotification } from '@/core/helpers/utils';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';

export default defineComponent({
  name: 'doi-mat-khau-modal',

  components: { ButtonCustom, LabelCustom },

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      default: 0,
    },
    userName: {
      type: String,
      default: '',
    },
  },

  emits: ['close', 'success'],

  setup(props, { emit }) {
    const { ButtonsType, ButtonTypeColors } = useButtonCustom();
    const isVisible = ref(false);
    const loading = ref(false);
    const formRef = ref<null | HTMLFormElement>(null);
    const form = ref({
      mat_khau: '',
      mat_khau_confirm: '',
    });

    const validateConfirmPassword = (
      _rule: unknown,
      value: string,
      callback: (error?: Error) => void
    ) => {
      if (!value) {
        callback(new Error('Mật khẩu xác nhận không được để trống'));
        return;
      }

      if (value !== form.value.mat_khau) {
        callback(new Error('Mật khẩu xác nhận không trùng khớp'));
        return;
      }

      callback();
    };

    const rules = {
      mat_khau: [
        {
          required: true,
          message: 'Mật khẩu không được để trống',
          trigger: 'blur',
        },
        {
          min: 8,
          message: 'Mật khẩu phải có ít nhất 8 ký tự',
          trigger: 'blur',
        },
      ],
      mat_khau_confirm: [
        {
          validator: validateConfirmPassword,
          trigger: 'blur',
        },
      ],
    };

    watch(
      () => props.isOpen,
      (value) => {
        isVisible.value = value;
        if (value) {
          form.value = { mat_khau: '', mat_khau_confirm: '' };
        }
      }
    );

    const onClose = () => {
      isVisible.value = false;
      emit('close');
    };

    const submit = () => {
      if (!formRef.value) return;

      formRef.value.validate(async (valid) => {
        if (!valid) return;

        try {
          loading.value = true;
          await UserService.updatePassword(props.userId, {
            mat_khau: form.value.mat_khau,
            mat_khau_confirm: form.value.mat_khau_confirm,
          });
          await swalNotification('Cập nhật mật khẩu thành công', 'success');
          emit('success');
          onClose();
        } catch (error) {
          await swalErrNotification(
            error,
            'Không thể cập nhật mật khẩu, vui lòng thử lại'
          );
        } finally {
          loading.value = false;
        }
      });
    };

    return {
      ButtonsType,
      ButtonTypeColors,
      form,
      formRef,
      isVisible,
      loading,
      onClose,
      rules,
      submit,
    };
  },
});
